<app-modal-template
  [hasCloseButton]="true"
  [title]="'Attendance Note' | translate"
  [size]="PencilModalSizeEnum.MEDIUM"
  class="attendance-note-container"
  (closeButtonClicked)="cancelClick()"
>
  <div content-description>
    <!-- User Info -->
    <div class="user-info-container">
      <app-profile-photo
        class="user-photo"
        [user]="attendanceUser"
        width="36"
        fontSize="20"
        [isClickEnabled]="false"
      >
      </app-profile-photo>

      <div class="name-and-role-container">
        <div class="name">{{ attendanceUser.name }}</div>
        <div class="role">{{ attendanceUser.role | translate }}</div>
      </div>
      <app-attendance-status-indicator
        [attendanceUser]="attendanceUser"
        [eventId]="eventId"
        [mode]="AttendanceStatusMode.READ_ONLY"
        class="status-indicator"
      ></app-attendance-status-indicator>
    </div>
    <!--    View mode only when user don't have permissions to edit notes-->
    <div class="note-view-container" *ngIf="isViewMode; else noteEditTemplate">
      <span class="note-text">{{ attendanceUser.notes }}</span>
    </div>
    <!-- Note Editor in case user has permissions -->
    <ng-template #noteEditTemplate>
      <div class="note-input-container">
        <div class="note-title">{{ 'NOTE' | translate }}</div>
        <textarea
          class="note-container"
          [(ngModel)]="updatedNotes"
          [placeholder]="'Add attendance note here' | translate"
          [maxLength]="NOTE_MAX_LENGTH"
        ></textarea>
      </div>
    </ng-template>
  </div>

  <div *ngIf="!isViewMode" content-actions>
    <app-pencil-button
      class="note-btn"
      icon="close"
      theme="secondary"
      buttonType="button"
      [iconConfig]="{
        type: 'material-icon'
      }"
      [label]="'Cancel' | translate"
      (clickEvent)="cancelClick()"
    >
    </app-pencil-button>

    <app-pencil-button
      class="note-btn"
      theme="primary"
      icon="done"
      [iconConfig]="{
        type: 'material-icon'
      }"
      [disabled]="updatedNotes === attendanceUser.notes"
      [label]="'Done' | translate"
      (clickEvent)="doneClick()"
    >
    </app-pencil-button>
  </div>
</app-modal-template>
